module.exports = __webpack_public_path__ + "static/media/MP1.dc594fb6.png";